import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corporation-add',
  templateUrl: './corporation-add.component.html',
  styleUrls: ['./corporation-add.component.css']
})
export class CorporationAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
